module.exports = __webpack_public_path__ + "2336df54ce2d01039f4a1d861e26449c.jpg";